// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"547":"0b0b1bb3","627":"12481ef1"}[chunkId] + ".chunk.css";
};